import {blockOverlayEventBus, HIDE_BLOCK_OVERLAY, SHOW_BLOCK_OVERLAY} from "@/assets/plugins/block-overlay/constants";

export const showBlockOverlay = (callback) => {
    blockOverlayEventBus.$emit(SHOW_BLOCK_OVERLAY, callback);
};

export const hideBlockOverlay = () => {
    blockOverlayEventBus.$emit(HIDE_BLOCK_OVERLAY);
};